<template>
  <section class="tachyon-container">
    <div class="advantages-section">
      <div v-for="(advantage, index) in advantages" :key="index" class="advantages-wrapper">
        <div class="advantages-block">
          <v-lazy-image :src="advantage.img" src-placeholder="/static/img/placeholder.jpg" :alt="advantage.alt"/>
          <h2>{{advantage.title}}</h2>
          <div v-html="advantage.text"></div>
        </div>
        <hr>
      </div>
      <carousel class="tachyon-carousel"
                :perPage="1"
                :navigationClickTargetSize="12"
                :navigationNextLabel="``"
                :navigationPrevLabel="``"
                :minSwipeDistance="30"
                paginationColor="#bed2e9"
                paginationActiveColor="transparent"
      >
        <slide v-for="(advantage, index) in advantages" :key="index">
          <div class="slider-title">
            <v-lazy-image :src="advantage.img" src-placeholder="/static/img/placeholder.jpg" :alt="advantage.alt"/>
            <h2>{{advantage.title}}</h2>
          </div>
          <div class="slider-text" v-html="advantage.text"></div>
        </slide>
      </carousel>
    </div>
  </section>
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    name: 'Advantages',
    components: {
      Carousel,
      Slide
    },
    data () {
      return {
        advantages: [
          {
            img: '/static/img/features_page/ai_icon.svg',
            alt: 'ai/machine learning pilot project',
            title: 'Your gateway to a successful AI/Machine Learning pilot project',
            text: `<p>The simplest, quickest and cheapest way to track, collect, clean and democratise your big data.</p>
                   <p>Tachyon is ideal product to pilot any machine learning project for your business, with the scalability to promote to full production at any time.</p>`
          },
          {
            img: '/static/img/features_page/pipeline_icon.svg',
            alt: 'scalable big data pipeline',
            title: 'The Most performant & scalable big data pipeline in the market',
            text: `<p>Your path through a digital transformation doesn’t have to be complex, long and costly one.</p>
                   <p>Tachyon is a simple, highly scalable, ultra performant big data collection,consolidation and democratisation platform.</p>`
          }
        ]
      }
    }
  }
</script>

<style scoped>
  .advantages-section {
    background: #fff;
    padding: 60px 70px 80px 40px;
    margin-top: 30px;
    box-shadow: 0 4px 34px rgba(0, 0, 0, 0.07);
    border-radius: 4px;
  }
  .advantages-section .advantages-block {
    display: flex;
    justify-content: space-between;
  }
  .advantages-section .advantages-block:last-child img {
    margin-left: 28px;
  }
  .advantages-section h2 {
    font-family: 'RubicMedium', sans-serif;
    color: #37406f;
    font-weight: 500;
    font-size: 42px;
    line-height: 50px;
    width: 356px;
  }
  .advantages-section >>> p {
    width: 400px;
    color: #545454;
  }
  .advantages-section hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ebebeb;
    margin: 2em 0;
    padding: 0;
  }
  .advantages-wrapper:nth-child(2) hr {
    display: none;
  }
  .tachyon-carousel {
    display: none;
  }
  .advantages-section >>> .VueCarousel-pagination {
    margin-top: -30px;
  }
  .advantages-section >>> .VueCarousel-dot {
    margin: 10px;
    padding: 0 !important;
  }
  .advantages-section >>> .VueCarousel-dot--active {
    background-color: #2190f7 !important;
  }
  .slider-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
  }
  .slider-text {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 1300px) {
    .advantages-section {
      padding-right: 40px;
    }
    .advantages-section img {
      margin-right: 15px;
    }
    .advantages-wrapper h2 {
      margin-right: 15px;
    }
  }
  @media (max-width: 1199px) {
    .advantages-wrapper img {
      width: 40%;
      max-width: 250px;
    }
    .advantages-wrapper h2 {
      font-size: 40px;
    }
    .advantages-wrapper >>> p {
      width: 300px;
    }
  }
  @media (max-width: 991px) {
    .advantages-section {
      width: 100%;
      max-width: 730px;
      padding-bottom: 40px;
      margin-left: auto;
      margin-right: auto;
    }
    .advantages-wrapper {
      display: none;
    }
    .tachyon-carousel {
      display: block;
    }
    .advantages-section >>> p {
      width: 100%;
      color: #545454;
    }
  }
  @media (max-width: 767px) {
    .tachyon-container {
      width: 100% !important;
    }
    .advantages-section {
      max-width: 100%;
      border-radius: 0;
      box-shadow: none;
      border-bottom: 1px solid #ebebeb;
    }
    .advantages-section img {
      width: 37%;
      margin-right: 0;
    }
    .slider-title h2 {
      width: 60%;
      font-size: 36px;
      line-height: 42px;
    }
  }
  @media (max-width: 575px) {
    .advantages-section h2 {
      font-size: 30px;
      line-height: 36px;
    }
  }
  @media (max-width: 479px) {
    .advantages-section {
      padding: 30px 15px 20px;
    }
    .advantages-section h2 {
      font-size: 22px;
      line-height: 27px;
    }
    .slider-text {
      font-size: 14px;
      line-height: 22px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Features/Advantages.vue